export const dateFormat = 'DD MMM YY - HH:mm'
export const emailDateFormat = 'DD/MMM/YY HH:mm'
export const fullYearDateFormat = 'DD-MMM-YYYY'
export const amPmTimeFormat = 'HH:mm a'
export const fullYearTimeFormat = 'DD MMM YYYY HH:mm'

export const dispositionFilename = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/

// eslint-disable-next-line
export const email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const phone = /^[\s\S]*\S[\s\S]*$/ // eslint-disable-line

export const forbiddenList = {
  getTender: /\/tenders\/[a-z0-9]{24}$/,
  getProject: /\/projects\/[a-z0-9]{24}$/,
}

export const decimal = /^([1-9]+\d*|[0])(\.\d{1,2})?$/
export const leadingZeroDecimal = /^([0]+)([1-9]+\d*|[0])(\.\d{0,2})?$/
export const integer = /^[1-9]\d*$/
export const decimalFilter = /[^0-9.]+/ig
export const integerFilter = /[^0-9]+/ig
export const multiDotFilter = /[.]{2,}/ig
export const nonNumericCharsInCurrency = /[$¥€£,]/g

export const noExtendSessionPaths = {
  login: /\/login$/,
  pubLogin: /\/pub\/login$/,
  authenticationCode: /\/pub\/authentication-code$/,
  vendorLogin: /\/vendors\/login$/,
  vendorForgot: /\/pub\/forgot$/,
  vendorReset: /\/pub\/reset(\/.*)?$/,
  vendorResetPwd: /\/pub\/resetpwd(\/.*)?$/,
  notFound: /\/404$/,
  contractorTermsOfUse: /\/vendors\/terms-of-use$/,
  tenantTermsOfUse: /\/tenants\/terms-of-use$/,
  tenantPrivacyPolicy: /\/tenants\/private-policy$/,
  unlockAccount: /\/pub\/unlock$/,
  confirmUnlock: /\/pub\/confirm-unlock$/,
}

export const cacheEnableUrls = {
  buildings: /\/buildings/,
  docs: /\/docs/,
  insurance: /\/insurances/,
  inspections: /\/inspections/,
  guidelines: /\/guidelines/,
  project: /\/projects/,
  tenantProject: /\/tenant_projects/,
  workPermits: /\/work_permits/,
}

export const longTermCacheUrls = {
  buildings: /\/buildings/,
  guidelines: /\/guidelines/,
}

export const nonZeroDecimal = /^([1-9]{1}[0-9]{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{1,2})|(\.\d{1,2}))$|^([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})|0(\.\d{1,2})|(\.\d{1,2}))$/ // eslint-disable-line
export const decimalWithComma = /^([1-9]{1}[0-9]{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$/ // eslint-disable-line
export const integerWithComma = /^([1-9]{1}[0-9]{0,2}(\,\d{3})*|[1-9]{1}\d{0,}|0)$|^([1-9]{1}\d{0,2}(\,\d{3})*|[1-9]{1}\d{0,}|0)$/ // eslint-disable-line
export const nonEmptyString = /^[\s\S]*\S[\s\S]*$/ // eslint-disable-line
export const time = /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$/

// <table> excluded from the list in https://developer.mozilla.org/en-US/docs/Web/HTML/Block-level_elements
export const blockElementsStartTag = /<(address|article|aside|blockquote|details|dialog|dd|div|dl|dt|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|li|main|nav|ol|p|pre|section|ul)[^>]*>/g
export const blockElementsEndTag = /<\/(address|article|aside|blockquote|details|dialog|dd|div|dl|dt|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hgroup|hr|li|main|nav|ol|p|pre|section|ul)>/g
export const lastBrInSpan = /<br[^>]*>\s*<\/span>/g
export const multipleBrs = /(\s*<br[^>]*>\s*)+/g
